import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  BorrowalVsNonBorrowalReportAPI,
  BorrowalVSNonBorrowalReportResponse,
} from "../../../api/tenantInternalReports";
import { getCurrentMonthKey, saveBlob } from "../../../lib/utils";
import { showErrorToast } from "../../../lib/toast";
import { buildBorrowalVsNonBorrowalDateWindows } from "./reportWindows";
import { RootState } from "../../../app/store";
import { ExportFormat } from "../../../api/download";

export const fetchBorrowalVsNonBorrowalReportThunk = createAsyncThunk<
  BorrowalVSNonBorrowalReportResponse,
  { period?: string },
  { rejectValue: string }
>("borrowalVsNonBorrowalReport/fetch", async ({ period }, { rejectWithValue }) => {
  try {
    period = period ?? getCurrentMonthKey();
    return await BorrowalVsNonBorrowalReportAPI.fetch(buildBorrowalVsNonBorrowalDateWindows(period));
  } catch (error: any) {
    return rejectWithValue(error?.message || "Failed to fetch fraud overview");
  }
},
{
    condition: ({period}, { getState }) => {
      const state = getState() as RootState;
      period = period ?? getCurrentMonthKey();
      const { status, selectedPeriod } = state.borrowalVsNonBorrowalReportData;

      if (status === "succeeded" && selectedPeriod === period) {
        return false;
      }

      if (status === "loading") {
        return false;
      }

      return true;
    },
  }
);

export const downloadBorrowalVsNonBorrowalReportThunk = createAsyncThunk<
  void,
  { period?: string; format: ExportFormat }
>(
  "internalReports/downloadBorrowalVsNonBorrowal",
  async ({ period, format }) => {
    try {
      const date_windows = buildBorrowalVsNonBorrowalDateWindows(
        period ?? getCurrentMonthKey()
      );
      const { blob, fileName } = await BorrowalVsNonBorrowalReportAPI.download({
        date_windows,
        format,
      });
      saveBlob(blob, fileName);
    } catch (error) {
      console.error(error);
      showErrorToast("Could not start the download");
    }
  }
);
